import { ContributionVEFStatus, } from '../../types';
import { teleserviceMocked } from './teleservice';
export const responseDemandesWithContributionsVEF = {
    aggregations: {
        formationTitle: {
            doc_count_error_upper_bound: 0,
            sum_other_doc_count: 0,
            buckets: [
                {
                    key: 'Discipline 1',
                    doc_count: 1,
                },
                {
                    key: 'Discipline 2',
                    doc_count: 1,
                },
            ],
        },
    },
    data: [
        {
            id: 'test1',
            reference: 'demande1',
            title: 'title1',
            referenceAdministrative: 'refAdmin1',
            history: {},
            primaryActions: [
                {
                    type: 'check-validate',
                },
            ],
            secondaryActions: [],
            beneficiaires: [
                {
                    fullName: 'USER Un',
                },
            ],
            bourse: {
                formationTitle: 'Discipline 1',
                formationAnnee: '1e année',
                formationCursus: 'Temps plein',
                formationNombreHeures: 10,
                formationDateEntree: '2024-01-01T00:00:00.000Z',
                formationDateFin: '2024-12-12T00:00:00.000Z',
                contributionVEFStatus: ContributionVEFStatus.REQUESTED,
            },
            contributionVef: {
                reference: 'contribution-requested',
                status: ContributionVEFStatus.REQUESTED,
                history: {
                    begin: {
                        date: '2024-01-01T00:00:00.000Z',
                        user: {
                            href: '/monsieur-abc',
                            title: 'Mr ABC',
                        },
                    },
                    events: [
                        {
                            type: 'status',
                            reference: 'REQUESTED',
                            date: '2024-01-01T00:00:00.000Z',
                            user: {
                                href: '/monsieur-abc',
                                title: 'Mr ABC',
                            },
                        },
                    ],
                },
            },
            teleservice: teleserviceMocked,
        },
        {
            id: 'test2',
            reference: 'demande2',
            title: 'title2',
            referenceAdministrative: 'refAdmin2',
            history: {},
            beneficiaires: [
                {
                    fullName: 'USER Deux',
                },
            ],
            bourse: {
                formationTitle: 'Discipline 2',
                formationAnnee: '2e année',
                formationCursus: 'Temps plein',
                formationNombreHeures: 10,
                formationDateEntree: '2024-01-01T00:00:00.000Z',
                formationDateFin: '2024-12-12T00:00:00.000Z',
                contributionVEFStatus: ContributionVEFStatus.CHECKED,
            },
            primaryActions: [{ type: 'validate' }],
            secondaryActions: [],
            contributionVef: {
                reference: 'contribution-checked',
                status: ContributionVEFStatus.CHECKED,
                history: {
                    begin: {
                        date: '2024-01-01T00:00:00.000Z',
                        user: {
                            href: '/monsieur1',
                            title: 'Mr Un',
                        },
                    },
                    events: [
                        {
                            type: 'status',
                            reference: 'REQUESTED',
                            date: '2024-01-01T00:00:00.000Z',
                            user: {
                                href: '/monsieur1',
                                title: 'Mr Un',
                            },
                        },
                        {
                            type: 'status',
                            reference: 'CHECKED',
                            date: '02/01/24',
                            user: {
                                href: '/madame-def',
                                title: 'Mme DEF',
                            },
                        },
                    ],
                },
            },
            teleservice: teleserviceMocked,
        },
    ],
    meta: {
        total: 2,
        offset: 0,
        limit: 10,
    },
};
export const demandesWithContributionVEF = [
    {
        id: '/demande1',
        reference: 'demande1',
        referenceAdministrative: '1',
        title: 'Demande 1',
        history: {},
        primaryActions: [
            {
                type: 'check-validate',
            },
        ],
        secondaryActions: [],
        cloture: {
            value: false,
        },
        beneficiaires: [
            {
                fullName: 'USER Un',
            },
        ],
        contributionVef: {
            reference: 'contribution-requested',
            status: ContributionVEFStatus.REQUESTED,
            history: {
                events: [
                    {
                        type: 'status',
                        reference: 'REQUESTED',
                        date: '2024-01-01T00:00:00.000Z',
                        user: {
                            href: '/user',
                            title: 'User',
                        },
                    },
                ],
            },
        },
        bourse: {
            formationTitle: 'Discipline 1',
            formationAnnee: '1e année',
            formationCursus: 'Temps plein',
            formationNombreHeures: 10,
            formationDateEntree: '2024-01-01T00:00:00.000Z',
            formationDateFin: '2024-12-12T00:00:00.000Z',
            contributionVEFStatus: ContributionVEFStatus.REQUESTED,
        },
        teleservice: teleserviceMocked,
    },
    {
        id: '/demande2',
        reference: 'demande2',
        referenceAdministrative: '2',
        title: 'Demande 2',
        history: {},
        primaryActions: [
            {
                type: 'validate',
            },
        ],
        secondaryActions: [],
        cloture: {
            value: false,
        },
        beneficiaires: [
            {
                fullName: 'USER Deux',
            },
        ],
        contributionVef: {
            reference: 'contribution-checked',
            status: ContributionVEFStatus.CHECKED,
            history: {
                events: [
                    {
                        type: 'status',
                        reference: 'REQUESTED',
                        date: '2024-01-01T00:00:00.000Z',
                        user: {
                            href: '/user',
                            title: 'User',
                        },
                    },
                    {
                        type: 'status',
                        reference: 'CHECKED',
                        date: '2024-01-02T00:00:00.000Z',
                        user: {
                            href: '/etb',
                            title: 'Etablissement',
                        },
                    },
                ],
            },
        },
        bourse: {
            formationTitle: 'Discipline 2',
            formationAnnee: '2e année',
            formationCursus: 'Temps plein',
            formationNombreHeures: 10,
            formationDateEntree: '2024-01-01T00:00:00.000Z',
            formationDateFin: '2024-12-12T00:00:00.000Z',
            contributionVEFStatus: ContributionVEFStatus.CHECKED,
        },
        teleservice: teleserviceMocked,
    },
];
export const formattedContributionsVEF = [
    {
        referenceDemande: 'demande1',
        referenceContributionVEF: 'contribution-requested',
        title: `Discipline 1 - 1e année de USER Un`,
        bourseInfo: 'Du 01/01/2024 au 12/12/2024 - Temps plein - 10h',
        actions: [
            {
                id: 'check-validate',
                title: 'Vérifier puis valider',
                icon: { icon: 'chevron-right' },
                variant: 'primary',
            },
        ],
        status: ContributionVEFStatus.REQUESTED,
        tag: {
            color: 'warning',
            title: 'Demande non vérifiée',
        },
        beneficiaireFullName: 'USER Un',
    },
    {
        referenceDemande: 'demande2',
        referenceContributionVEF: 'contribution-checked',
        title: `Discipline 2 - 2e année de USER Deux`,
        bourseInfo: 'Du 01/01/2024 au 12/12/2024 - Temps plein - 10h',
        actions: [{ id: 'validate', title: 'Valider', icon: { icon: 'chevron-right' }, variant: 'primary' }],
        status: ContributionVEFStatus.CHECKED,
        tag: {
            color: 'success',
            icon: 'check',
            title: 'Demande vérifiée',
        },
        beneficiaireFullName: 'USER Deux',
    },
];
//# sourceMappingURL=demande-with-contribution-vef.js.map